import * as Config from '../config/Config';
import * as User from '../helpers/User';
import * as Common from '../helpers/Common';

export function setInbox(inbox) {
    return { type: "SET_INBOX", inbox};
}

export function getInbox() {
    return dispatch => {
        
        
        let learnerID = Common.getUserData("id", true);
     
        let admin_role = Common.getUserData("role", true);

        fetch(Config.domainUrl+'messages-site/get-inbox', {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'Authorization':'Bearer ' +Common.getTokenData()
            },

              body: JSON.stringify({
                learner_id:learnerID,admin_role:admin_role
              })
            }).then((response) => response.json())
           .then((responseJson) => {
                if(responseJson.status != 0){
                    dispatch(setInbox(responseJson));
                }

            }).catch(error => {
                console.error(error);
                
            });             
     
    };
}




// WEBPACK FOOTER //
// ./src/actions/inboxAction.js